import React, { useEffect } from 'react';

const Language = ({ data, language, GetData }) => {

  useEffect(() => {
    GetData(language);
  }, []);

  //console.log('data', data);
  const changeLang = lang => {
    //console.log('lang', lang);
    language = lang;
    GetData(language);
  }


  return (
    <div className="language-wrapper">
          {data && data.languages.map((item, index) => (
              <div key={index} className="language" onClick={() => {changeLang(item)}} >{item}</div>
          ))}
    </div>
  );
};

export default Language;
